import ko from "knockout";
import * as _ from "underscore";

export interface IFilter {
    filterKey: string;
    filterName: string;
    filterValue: KnockoutObservable<any>;
    filterValueText?: KnockoutObservable<string>;
    appendValue: boolean;
    defaultValue?: any;
}

type FakeFilter = {
    key: string;
};

type FilterItem = {
    key: string;
    text: KnockoutObservable<string>;
};

export default class FilterHelper {
    selectedFilters = ko.observableArray<FilterItem>([]);

    /// masterFilters should be an array of filters where each filter should contain following members.
    /// filterKey: A unique key to identify the filter. e.g., "FromDate".
    /// filterName: Display name of the filter e.g., "From Date".
    /// filterValue: An observable that points to the value of the filter.
    /// appendValue: A boolean that indicates whether the value of filter should be appended to the resulting display string.
    ///              Set it to true for non boolean filters e.g., when set to true it will display string like "From Date: 20-01-2015".
    /// defaultValue: This is an optional member which should be set when the default value for the filter is different than default value for
    ///               its type. e.g., for a filter of type string if the default value is "-1" then it should be set to "-1". If the default value
    ///               is empty string then this member need not be provided.
    constructor(private readonly masterFilters: KnockoutObservableArray<IFilter>) {
        ko.computed(() => {
            _.each(this.masterFilters(), (filter: IFilter) => {
                if (filter.filterValue() && filter.filterValue() !== filter.defaultValue) {
                    let filterDisplayName = filter.filterName;
                    if (filter.appendValue) {
                        if (filter.filterValueText) {
                            filterDisplayName += ": " + filter.filterValueText();
                        } else {
                            filterDisplayName += ": " + filter.filterValue();
                        }
                    }

                    this.updateOrAddFilter(filter.filterKey, filterDisplayName);
                } else {
                    const isSelected = _.any(this.selectedFilters.peek(), selectedFilter => {
                        return selectedFilter.key === filter.filterKey;
                    });

                    if (isSelected) {
                        this.removeFilter({ key: filter.filterKey });
                    }
                }
            });
        });
    }

    removeFilter(filter: FakeFilter) {
        const removedFilter: IFilter = _.find(this.masterFilters(), (item: IFilter) => {
            return item.filterKey == filter.key;
        });

        if (removedFilter) {
            // Revert the filter value to default value, if it is provided.
            if (removedFilter.defaultValue) {
                removedFilter.filterValue(removedFilter.defaultValue);
            } else {
                // Revert to default value for the type. Ignore null or undefined values.
                if (removedFilter.filterValue()) {
                    const defaultValue = this.getDefaultValue(removedFilter.filterValue());
                    removedFilter.filterValue(defaultValue);
                }
            }
        }

        this.selectedFilters.remove(function (item: FakeFilter) {
            return item.key == filter.key;
        });
    }

    private updateOrAddFilter(filterKey: string, filterText: string) {
        const existingFilter = _.find(this.selectedFilters(), item => {
            return item.key == filterKey;
        });

        if (existingFilter) {
            existingFilter.text(filterText);
        } else {
            this.selectedFilters.push({ key: filterKey, text: ko.observable(filterText) });
        }
    }

    clearAllFilters() {
        this.selectedFilters([]);
        // Clears all selected filters.
        _.each(this.masterFilters(), (filter: IFilter) => {
            //removeFilter({ key: filter.filterKey });

            filter.filterValue(filter.defaultValue);
        });
    }

    private getDefaultValue(val: any) {
        switch (typeof val) {
            case "string":
                return "";
            case "boolean":
                return false;
            case "number":
                return "";
            default:
                throw new Error("Type not supported. Please provide a default value.");
        }
    }
}
